export default class ProductCategory {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new ProductCategory(json);
  }
}
